import Swiper from 'swiper/bundle';

const [d] = [document];

class Blocks {
  heroCopy() {
    const heroCopy = d.querySelector('.p-home__hero-copy');
    const heroTitle = heroCopy
      ? heroCopy.querySelector('.p-home__hero-title')
      : null;

    if (!heroCopy || !heroTitle) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      heroCopy.classList.add('is-title-visible', 'is-text-visible');
      return;
    }

    const showText = (event) => {
      if (event.target !== heroTitle || event.propertyName !== 'transform') return;

      heroTitle.removeEventListener('transitionend', showText);
      heroCopy.classList.add('is-text-visible');
    };

    heroTitle.addEventListener('transitionend', showText);
    requestAnimationFrame(() => {
      heroCopy.classList.add('is-title-visible');
    });
  }

  fixedLink() {
    const fixedLinkActions = d.querySelector('.p-home__fixed-link-actions');
    const footer = d.querySelector('.l-footer');
    const showOffset = 100;
    let isFooterVisible = false;

    if (!fixedLinkActions || !footer) return;

    const updateVisibility = () => {
      const isFirstView = window.scrollY <= showOffset;
      fixedLinkActions.classList.toggle(
        'is-hidden',
        isFirstView || isFooterVisible
      );
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        isFooterVisible = entry.isIntersecting;
        updateVisibility();
      });
    });

    observer.observe(footer);
    window.addEventListener('scroll', updateVisibility, { passive: true });
    updateVisibility();
  }

  mainvisual() {
    //メインスライダー
    new Swiper('[data-plugin="heroSlider"]', {
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      speed: 1000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      grabCursor: true,
    });
  }

  pointSlider() {
    new Swiper('[data-plugin="pointSlider"]', {
      // slidesPerView: 1,
      slidesPerView: "auto",
      spaceBetween: 24,
      loop: true,
      loopAdditionalSlides: 1,
      centeredSlides: true,
      initialSlide: 0,
      speed: 1000,
      // autoplay: {
      //     delay: 4000,
      //     disableOnInteraction: false,
      // },
      grabCursor: true,
      watchSlidesProgress: true,
      navigation: {
        prevEl: '.p-home__point-button--prev',
        nextEl: '.p-home__point-button--next',
      },
      breakpoints: {
        577: {
          // slidesPerView: 2,
          spaceBetween: 32,
        },
        1201: {
          // slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    });
  }
}

async function instaAPI() {
    // 子要素<ul>を追加
    // document.querySelector('#insta').insertAdjacentHTML('beforeend', '<ul></ul>');

    let cards = 4; // insta投稿の表示件数を指定
    let access_token =
        'EAAL3gopjTgQBSsXn1vwnS9pQkG23VpmT8WSVbWrUhNLLyPHYn7TZB7Py6AZB5sC4yR3vAiDm4yzj81fZC021XsKqM5aZBIUxBHiE7XtS7hNYxd3ZCGs5QZCBeahLeZBS3JvNOpV2dcCgh06jZB52nLIZBov6snqjbWN1pkoOZA5uUXl8ZB3qzPzEVhtfH6ZCYuKYWPyq'; // アクセストークン
    let business_id = '17841439650817265'; // アクセストークン
    const response = await fetch(
        `https://graph.facebook.com/v26.0/${business_id}?fields=name,media.limit(${cards}){ caption,media_url,thumbnail_url,permalink,like_count,comments_count,media_type}&access_token=${access_token}`
    );

    if (response.status === 200) {
        const resObjects = await response.json();
        // console.log(resObjects.media);
        //（挙動への影響は一切無いものの）オブジェクト{resObjects.media}内のプロパティ{paging}のせいで「instaItems[1]が無いというエラー」が出るので削除して以降の処理を進めていく
        delete resObjects.media.paging;

        Object.entries(resObjects.media).forEach((instaItems) => {
            // console.log(instaItems);
            instaItems[1].forEach((eachItem) => {
                if (eachItem.media_url !== null) {
                    // 投稿が動画か否かを判定して{media}を変更
                    if (eachItem.media_type === 'VIDEO') {
                        eachItem.media = eachItem.thumbnail_url;
                    } else {
                        eachItem.media = eachItem.media_url;
                    }

                    document
                        .querySelector('#instafeed')
                        .insertAdjacentHTML(
                            'beforeend',
                            `<li class="p-home__instafeed-item"><a href="${eachItem.permalink}" target="_blank" rel="noopener"><img src="${eachItem.media}"></a></li>`
                        );
                }
            });
        });
    } else {
        document
            .querySelector('#instafeed')
            .insertAdjacentHTML(
                'beforeend',
                '<li class="p-home__instafeed-error">読み込めませんでした</li>'
            );
    }
}

const domReady = () => {
  const blocks = new Blocks();
  blocks.heroCopy();
  blocks.fixedLink();
  blocks.mainvisual();
  blocks.pointSlider();
  instaAPI();
};

export default function HOME() {
  d.addEventListener('DOMContentLoaded', domReady);
}
